import PatientAccounts from './PatientAccounts';

export default PatientAccounts;
